// @ts-nocheck
import React, { useState } from "react";
import genRequest from "includes/request";
import { useQuery, useQueryClient } from "react-query";
import formatDate from "includes/formatDate";
import download_file from "includes/dl_file";
import moment from "moment";
import "./AnimationPreview.css";
import { t } from "i18next";
import PostContent from "Pages/Posts/components/PostPreview/components/PostContent/PostContent";
import useAccount from "classes/Accounts/hooks/useAccount";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import Button from "components/Button/Button";
import useTemplate from "hooks/useTemplate";
import AsyncPostPreview from "Pages/Posts/components/PostPreview/AsyncPostPreview";
import UserRow from "components/User/UserRow/UserRow";
import { getRightFromTypeId } from "includes/mappingTypeIdName";
import { returnRightsFromName } from "includes/rightType";

export default function AnimationPreview(props) {
	const event = props.event;
	const { account, isAdmin } = useAccount();
	const { getAppFunction } = useTemplate();

	const checkRight = () => {
		const rigthName = getRightFromTypeId(8);
		try {
			return returnRightsFromName(account.rights, rigthName);
		} catch (error) {
			return true;
		}
	};

	function genCalfile(post) {
		let extended = event.extendedProps;
		let ret = [
			"BEGIN:VCALENDAR",
			"CALSCALE:GREGORIAN",
			"PRODID:-//Onlyall.fr//" + event.title + "//FR",
			"VERSION:2.0",
			"BEGIN:VEVENT",
			"DTSTAMP:" + formatDate(extended?.lastChanged, "YMDThms"),
			"DTSTART:" + formatDate(event.start, "YMDThms"),
			"DTEND:" + formatDate(event.end, "YMDThms"),
			"SUMMARY:" + event.title,
			"DESCRIPTION:" + post?.txt?.replace(/\n/gi, "\\n"),
			"UID:OnlyAllEvent-" +
			event.id +
			(post?.postId ? "-" + post.postId : ""),
			"END:VEVENT",
			"END:VCALENDAR",
		];
		return ret;
	}

	function exportEvent(post) {
		let file = genCalfile(post).join("\n");
		download_file(file, "Événement - " + event.title, "text/calendar");
	}

	function handleModify(anim) {
		if (props.handleModify) props.handleModify(anim);
	}

	function handleClone(anim) {
		if (props.handleClone) props.handleClone(anim);
	}

	function handleDelete(anim) {
		if (props.handleDelete) props.handleDelete(anim);
	}

	const canParticipate = () => {
		let d = event.extendedProps?.displayParticipation;
		if (getAppFunction("AnimationsPage.CanParticipate") === false) return d;
		if (d === null) return getAppFunction("AnimationsPage.CanParticipate");
		return d;
	};

	const { isLoading, data, error } = useQuery(
		["Posts", "PostOfAnimation", event?.id],
		() => genRequest("posts/animation/" + event.id),
		{
			enabled: event?.id != null,
			onError: () => {
				let ret = event;
				ret.txt = "";
				return ret;
			},
			retry: 0,
		}
	);

	// `posts/animation/:id` returns an array (possibly empty).
	const linkedPost = Array.isArray(data) ? data[0] : data;

	const checkRightAndCorrectAuthor = () => {
		const dataAuthor = linkedPost?.employeeId;
		const selfAuthor = account?.employeeId;
		return checkRight() ? true : dataAuthor === selfAuthor;
	};

	if (isLoading)
		return (
			<div className="post-preview loading p-4">
				<div className="w-100 mb-4" style={{ height: "150px" }}></div>
				<div className="w-100"></div>
				<div className="w-50"></div>
				<div className="w-25"></div>
				<div className="w-35"></div>
			</div>
		);

	const isPassed = event.end < new Date();

	// `posts/animation/:id` returns an ARRAY (could be empty). The previous
	// code did `data.postId` which read `undefined` off the array → passed
	// `postId={undefined}` to AsyncPostPreview, which then rendered nothing.
	// The drawer would open with no title, no description, no dates — just
	// the participants section. Use `data?.[0]?.postId` and fall through to
	// FallbackAnimationPreview when no linked post exists.
	const linkedPostId = linkedPost?.postId;

	return (
		<div className="AnimationPreview">
			{!error && linkedPostId ? (
				<AsyncPostPreview
					className="radius-2"
					stats={false}
					key={event.id}
					postId={linkedPostId}
					animationId={event.id}
					responsive={props.responsive}
					extend={false}
					extendImages={false}
					header={<EventDates event={event} />}
					bottombar={false}
					topbar={false}
					resetCur={props.onClose}
				/>
			) : (
				<FallbackAnimationPreview
					exportEvent={exportEvent}
					event={event}
					isError={!!error}
				/>
			)}

			{canParticipate() && (
				<div className="cont mt-3 radius-2">
					<InfosFetcher
						queryFn={() =>
							genRequest(
								"animations/" +
								event.id +
								"/participants"
							)
						}
						queryKey={[
							"animations",
							event.id,
							"participants",
						]}
						options={{
							retry: 0,
						}}
						displayOnError={true}
						treat={(resp) => {
							const items = (resp ?? []).map((a) => ({
								...a,
								employeeId: a.employeeId ?? a.id,
							}));
							return (
								<div>
									<div className="font-bold text-uppercase">
										{t("Events.PARTICIPANT", {
											count: items.length,
										})}
									</div>
									{items.length > 0 && (
										<div
											style={{
												maxHeight: "300px",
												overflow: "auto",
											}}
										>
											{items.map((a) => (
												<UserRow
													async={true}
													key={a.employeeId}
													employeeId={a.employeeId}
													status={false}
												/>
											))}
										</div>
									)}
								</div>
							);
						}}
					/>
					{!isPassed && (
						<div className="mt-2 font-regular">
							<ParticipationButton
								animationId={event.id}
								isPassed={isPassed}
							/>
						</div>
					)}
				</div>
			)}
			{(isAdmin() || (props.export !== false && !isPassed)) && (
				<div className="cont mt-3 d-flex flex-column gap-2 admin-animationPreview">
					{props.export !== false && !isPassed && (
						<div>
							<Button
								className="btn btn-bg"
								onClick={() => exportEvent(linkedPost)}
							>
								{t("Events.EXPORT")}
							</Button>
						</div>
					)}
					{isAdmin() && (
						<>
							{checkRightAndCorrectAuthor() && (
								<div>
									<Button
										className="btn btn-blue"
										onClick={() => handleModify(event)}
									>
										{t("Events.MODIFY")}
									</Button>
								</div>
							)}
							{checkRight() && (
								<div>
									<Button
										className="btn btn-green"
										onClick={() => handleClone(event)}
									>
										{t("Commons.USE_AS_TEMPLATE")}
									</Button>
								</div>
							)}
							{checkRight() && (
								<div>
									<Button
										className="btn btn-red"
										onClick={() => handleDelete(event)}
									>
										{t("Commons.DELETE")}
									</Button>
								</div>
							)}
						</>
					)}
				</div>
			)}
		</div>
	);
}

function ParticipationButton({ animationId }) {
	const QCL = useQueryClient();
	const { account } = useAccount();
	const [parti, setParti] = useState(false);

	function handleParticipation() {
		let prom = null;
		if (parti) prom = cancelParticipation(parti.id ?? parti.participationId);
		else prom = participate();
		prom.then(() => {
			QCL.refetchQueries([
				"animations",
				animationId,
				"participants",
			]);
		});
		return prom;
	}

	const myEmployeeId = account.employeeId;

	const participate = () =>
		genRequest(
			"animations/" + animationId + "/participations",
			{
				employeeId: myEmployeeId,
				animationId: animationId,
				dateOfPublish: formatDate(),
			},
			"post"
		).then((resp) => setParti(resp));

	const cancelParticipation = (id) =>
		genRequest(
			"animations/participations/" + id,
			null,
			"delete"
		).then(() => setParti(false));

	const fetchParticipation = () =>
		genRequest(
			`animations/${animationId}/participations/employee/${myEmployeeId}`
		);

	const { isLoading } = useQuery(
		[
			"animations",
			animationId,
			"participations",
			"employee",
			account.employeeId,
		],
		fetchParticipation,
		{
			retry: 0,
			enabled: animationId ? true : false,
			onSuccess: (resp) => {
				setParti(resp ? resp : false);
			},
			onError: () => setParti(false),
		}
	);

	if (isLoading)
		return (
			<div className="loading secondary">
				<div className="p-2 py-3 w-100"></div>
			</div>
		);

	return (
		<Button
			className={"btn " + (parti ? "btn-red" : "btn-blue")}
			onClick={() => handleParticipation()}
		>
			{t(`Events.${parti ? "NO_PARTICIPATE" : "PARTICIPATE"}`)}
		</Button>
	);
}

function FallbackAnimationPreview({ event, isError }) {
	// `event.extendedProps` carries custom animation fields (description,
	// linkType…) but NOT `title` — FullCalendar puts the title at
	// `event.title`. Merge them so PostContent finds a populated `title`
	// and renders it; otherwise the drawer body shows only the date.
	const post = {
		title: event?.title,
		...(event?.extendedProps || {}),
	};

	return (
		<div className="FallbackAnimationPreview">
			<PostContent post={post} />
			<EventDates event={event} />
			{/* Only surface the load-error notice when the API actually
			    failed. The "no linked post" case (data is `[]`) is a
			    legitimate state, not an error — showing the error notice
			    confused users and tripped the E2E "erreur est survenue"
			    crash detector. */}
			{isError && (
				<div className="load-error mt-2">{t("Events.LOAD_ERROR_2")}</div>
			)}
		</div>
	);
}

function EventDates({ event }) {
	let format =
		"[" +
		t("Commons.FROM") +
		"] D MMMM YYYY [" +
		t("Commons.AT") +
		"] HH:mm";

	if (event.allDay) format = "[" + t("Commons.THE") + "] D MMMM YYYY";

	const startMoment = moment(event.start).locale(t("Code"));
	const endMoment = moment(event.end).locale(t("Code"));
	const endFormat =
		"[" +
		t("Commons.TO") +
		"] D MMMM YYYY [" +
		t("Commons.AT") +
		"] HH:mm";

	return (
		<div>
			{startMoment.isValid() && (
				<div>
					<span className="event-date" title={startMoment.format(format)}>
						{startMoment.format(format)}
					</span>
				</div>
			)}
			{!event.allDay && endMoment.isValid() && (
				<div>
					<span className="event-date" title={endMoment.format(endFormat)}>
						{endMoment.format(endFormat)}
					</span>
				</div>
			)}
		</div>
	);
}
